import { FC, ReactNode } from "react";
import { IconButton, SvgIcon } from "@mui/material";

import "./Icon.scss";

type IconProps = React.HTMLAttributes<HTMLSpanElement> & {
  src: ReactNode;
  className?: string;
  title?: string;
  onClick?: (event: React.MouseEvent<HTMLSpanElement, MouseEvent>) => void;
  ariaLabel?: string;
  size?: "small" | "medium" | "large";
  isCustom?: boolean;
  disabled?: boolean;
};

const Icon: FC<IconProps> = ({
  src,
  className,
  title,
  ariaLabel,
  onClick,
  size,
  isCustom,
  disabled
}: IconProps) => {
  return (
    <>
      {isCustom ? (
        <IconButton
          className={`icon-color ${className}`}
          aria-label={ariaLabel}
          title={title}
          size={size}
          onClick={onClick}
          disabled={disabled}
        >
          <SvgIcon className={`icon-color ${className}`}>{src}</SvgIcon>
        </IconButton>
      ) : (
        <IconButton
          className={`icon-color ${className}`}
          aria-label={ariaLabel}
          title={title}
          size={size}
          onClick={onClick}
          disabled={disabled}
        >
          {src}
        </IconButton>
      )}
    </>
  );
};

export default Icon;
